import { isDenebEnabled } from '@/const/flags'

import { TopPage as AltairTopPage } from './Top.altair'
import { TopPage as DenebTopPage } from './Top.deneb'

export const TopPage = isDenebEnabled ? DenebTopPage : AltairTopPage
